/**
 * inCust terminal API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IdType } from './idType';

export interface CustomerBenefitsAdjustOperationData {
  /**
   * Amount credited benefits
   */
  amount: number;
  /**
   * Comment
   */
  comment?: string;
  /**
   * Bonus points currency ISO string
   */
  currency?: string;
  /**
   * User identifier (phone number, card code, QR code). Minimum 3 chars
   */
  id: string;
  id_type?: IdType;
  /**
   * Value of promotional bonuses expire date
   */
  promotional_bonuses_expire_date?: string;
  /**
   * Value of promotional bonuses starting date
   */
  promotional_bonuses_starting_date?: string;
  /**
   * Skip notifications
   */
  skip_message?: boolean | null;
  /**
   * Special account ID
   */
  special_account_id?: string;
  /**
   * Benefit type
   */
  type: CustomerBenefitsAdjustOperationData.TypeEnum;
}
export namespace CustomerBenefitsAdjustOperationData {
  export type TypeEnum =
    | 'regular-bonuses'
    | 'promotional-bonuses'
    | 'special-account';
  export const TypeEnum = {
    RegularBonuses: 'regular-bonuses' as TypeEnum,
    PromotionalBonuses: 'promotional-bonuses' as TypeEnum,
    SpecialAccount: 'special-account' as TypeEnum
  };
}
